import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';

import { FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import {
  EArbitrageFilters,
  ECexPairFilters,
  EDexPairFilters,
  EGeneralFilters,
  EProjectFilters,
  ESolPairFilters,
  IFilters,
} from 'types/filters';
import { ICexPair, IDexPair } from 'types/pairs';

import { getProjectFiltersKey } from '../utils';

interface IPayload {
  cex?: {
    pair?: ICexPair;
    type: ECexPairFilters;
  };
  dex?: {
    pair?: IDexPair;
    type: EDexPairFilters;
  };
  sol?: {
    pair?: IDexPair;
    type: ESolPairFilters;
  };
  general?: EGeneralFilters;
  arbitrage?: EArbitrageFilters;
  project?: {
    projectId: number;
    type: EProjectFilters;
  };
}

export const clearFiltersReducer: CaseReducer<IFilters, PayloadAction<IPayload>> = (
  state,
  { payload },
) => {
  const { dex, cex, sol, general, arbitrage, project } = payload;

  if (general && state[general]) {
    state[general]!.filters = [];
    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (arbitrage && state.arbitrage[arbitrage]) {
    state.arbitrage[arbitrage]!.filters = [];
    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (project) {
    const key = getProjectFiltersKey(project.projectId, project.type);
    const projectEntry = state.project[key];
    if (!projectEntry) return;

    state.project[key] = {
      ...projectEntry,
      updated_at: new Date(Date.now()).toISOString(),
      filters: [],
    };

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  const pairId = cex ? cex.pair?.id : dex ? dex.pair?.id : sol ? sol.pair?.id : undefined;
  const type = dex ? dex.type : cex ? cex.type : sol ? sol.type : undefined;
  const key = cex ? 'cex' : dex ? 'dex' : 'sol';

  if (isNil(pairId) || isNil(type) || !state[key][pairId]) return;

  state[key][pairId]!.updated_at = new Date(Date.now()).toISOString();

  //@ts-ignore
  const filterTypeEntry = state[key][pairId]!.filters[type];

  //@ts-ignore
  state[key][pairId]!.filters[type] = {
    filters: [],
    setted: filterTypeEntry?.setted ?? [],
  };

  LocalStorage.set(FILTERS_CACHE_KEY, state);
};
